// action - state management
import { ACCOUNT_INITIALIZE, LOGIN, LOGOUT, ORG_DATA } from './actions';

export const initialState = {
    token: '',
    isLoggedIn: false,
    isInitialized: false,
    user: null,

};

//-----------------------|| ACCOUNT REDUCER ||-----------------------//

const accountReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACCOUNT_INITIALIZE: {
            const { isLoggedIn, user, token, role, org, org_member, assigned_agents, org_agent_seat_pools } = action.payload;
            return {
                ...state,
                isLoggedIn,
                isInitialized: true,
                token,
                user,
                role,
                org, 
                org_member,
                assigned_agents,
                org_agent_seat_pools
            };
        }
        case ORG_DATA: {
            const { org_data } = action.payload;
            return {
                ...state,
                org_data,
            };
        }
        case LOGIN: {
            const { user } = action.payload;
            return {
                ...state,
                isLoggedIn: true,
                user,
            };
        }
        case LOGOUT: {
            return {
                ...state,
                isLoggedIn: false,
                token: '',
                user: null
            };
        }
        default: {
            return { ...state };
        }
    }
};

export default accountReducer;
